import { memo, useLayoutEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

import { useSessionIsAuthorized } from '@/entities/auth';

import { getMainPath } from '@/shared/constants/router';
import { MetaPixelPageTracker } from '@/shared/lib/fbpixel';

import { AuthLayout } from '../../../layouts/auth/auth-layout';

const REDIRECT_ALLOWLIST = ['/checkout/boost'];

const validateRedirect = (raw: string | null): string | null => {
    if (!raw || !raw.startsWith('/')) return null;

    const pathname = raw.split('?')[0] ?? raw;

    const isAllowed = REDIRECT_ALLOWLIST.some(
        (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    );

    return isAllowed ? raw : null;
};

export const AuthRootElement = memo(() => {
    const isAuthorized = useSessionIsAuthorized();

    const [params] = useSearchParams();
    const redirectTo = validateRedirect(params.get('redirect'));

    useLayoutEffect(() => {
        document.body.toggleAttribute('auth');

        return () => {
            document.body.toggleAttribute('auth');
        };
    }, []);

    if (isAuthorized) {
        return (
            <Navigate
                replace
                to={redirectTo ?? getMainPath()}
            />
        );
    }

    return (
        <>
            <MetaPixelPageTracker />
            <AuthLayout />
        </>
    );
});

AuthRootElement.displayName = 'AuthRootElement';
